/* Detection attribute flags allow us to by-pass running the
 * classifiers or the clustering pipeline if a node is flagged */
export const FORM_CLUSTER_ATTR = "data-protonpass-form";

export const kFieldSelector = "input, select, textarea";
export const kFieldLabelSelector = `[class*="label"], [id*="label"]`;

export const kEmailSelector = 'input[name="email"], input[id="email"], input[name="user_email"]'; /* exact matches in dataset */
export const kPasswordSelector = 'input[type="password"], input[type="text"][id="password"]'; /* github.com signup defaults to non [type="password"]*/ // nosemgrep: ajinabraham.njsscan.generic.hardcoded_secrets.node_password
export const kCaptchaSelector = `[class*="captcha"], [id*="captcha"], [name*="captcha"]`;
export const kSocialSelector = `[class*=social], [aria-label*=with]`;

export const kEditorElements = ["body", "div", "section", "main"];
export const kEditorPatterns = [
  /** we avoid insensitive match on "editor" to avoid
   * false positives (eg: `creditor` on payment form) */
  '[class*="editor"]',
  '[class*="Editor"]',
  '[class*="EDITOR"]',
  '[id*="editor"]',
  '[id*="Editor"]',
  '[id*="EDITOR"]',
  '[class*="composer" i]',
  '[id*="composer" i]',
  '[class*="wysiwyg" i]',
  '[id*="wysiwyg" i]',
  '[class*="tinymce" i]',
  '[id*="tinymce" i]',
];

export const kEditorSelector = `[contenteditable="true"], :is(${kEditorElements.join(",")}):is(${kEditorPatterns.join(",")})`;

/** For clustering: `section` elements can be too aggressive when
 * resolving semantic groups during the clustering phase. eg: google
 * "virtual" forms (eg: account.google.com-otp.html sample) */
export const kDomDialogSelector = `[role="dialog"], [role="tabpanel"], [role="group"], [role="form"], [id*="modal"], [class*="modal"]`;
export const kDomClusterSelector = `${kDomDialogSelector}, header, main, nav, footer, aside`;
export const kDomGroupSelector = `${kDomClusterSelector}, section`;

export const kUsernameSelector = [
  'input[type="login"]',
  'input[type="username"]',
  'input[type="search"][name="loginName"]' /* citibank login */,
  'input[type="password"][name="userID"]' /* verizon [type="password"] username */,
  'input[type="password"][name="USERNAME"]' /* verizon [type="password"] username */,
  'input[name="account"]',
  'input[name="quickconnect-id"]',
].join(",");

export const kHiddenUsernameSelector = ['[name*="user" i]', '[id*="user" i]', '[name*="login" i]', '[id*="login" i]', '[name*="email" i]', '[id*="email" i]', '[name*="identifier" i]', '[id*="identifier" i]'].join(",");

/* Common selectors for "heading-like" elements:
 * Some websites tend to avoid using <h{n}> elements
 * and prefer using the role and aria-level attributes.
/* Also look for `div` nodes with 2x or 3x font-styles */
export const kHeadingSelector = [
  ...[1, 2, 3, 4, 5].flatMap((level) => [`h${level}, [aria-level="${level}"]`]),
  '[role="heading"]',
  '[class*="title"]',
  '[class*="header"]',
  '[name="title"]',
  'div[style*="font-size: 2"]',
  'div[style*="font-size: 3"]',
].join(",");

export const kButtonSubmitSelector = [
  'input[type="submit"]',
  'input[type="button"]',
  'input[type="image"][alt]',
  'button[id*="password" i]' /* forgot password buttons */,
  'button[type="submit"]',
  'button[type="button"]',
  'button[name="submit"]',
  'a[role="submit"]',
  'div[role="button"]',
  'div[role="submit"]',
].join(",");

export const kTextInputTypes = ["text", "email", "tel", "password", "number"];
export const kLayoutSelector = `div, section, aside, main, nav, label`;
export const kAnchorLinkSelector = `a, [role="link"], span[role="button"]`;

export const formCandidateSelector = `form, [${FORM_CLUSTER_ATTR}]`;
export const inputCandidateSelector = 'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="image"]):not([type="checkbox"])';
export const kInputIteratorSelector = 'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="image"]), textarea, select';
export const kButtonSelector = `button:not([type]), a[role="button"], ${kButtonSubmitSelector}`;
